import { render, staticRenderFns } from "./ClientTreeTab.vue?vue&type=template&id=2f85cb92"
import script from "./ClientTreeTab.vue?vue&type=script&lang=js"
export * from "./ClientTreeTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports